export default __webpack_public_path__ + "static/media/qr_icon.baaf4466.svg";